<template>
  <div class="main-content">
    <div class="content">
      <el-form ref="form" :model="form" label-width="84px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="年份：" style="margin-bottom: 10px">
              <el-select v-model="form.warnYear" value-key="value" style="width:100%;"  @change="yearsChange">
                <el-option v-for="(item,index) in yearsList"
                           :key="index"
                           :label="item"
                           :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1" >
            <el-form-item label="标段编号：" props="projectCode" style="margin-bottom: 10px">
              <el-input v-model="form.code" clearable placeholder="请输入内容搜索" @keyup.enter.native="seachBtn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9" :offset="1"  v-if="moreSearchItem" >
            <el-form-item label="标段名称：" props="projectName">
              <el-input v-model="form.name" style="width:100%" clearable placeholder="请输入内容搜索" @keyup.enter.native="seachBtn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="moreSearchItem">
            <el-form-item label="状态：" props="projectName" style="margin-bottom: 10px">
              <el-select v-model="form.historyid" style="width:100%">
                <el-option label="待处理" :value="-1"></el-option>
                <el-option label="已处理" :value="0"></el-option>
                <el-option label="忽略" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1" v-if="moreSearchItem">
            <el-form-item label="交易中心：">
              <el-select v-model="form.tradeId" clearable value-key="value" style="width:100%;" @change="seachBtn">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(item,index) in transactionCenterList" :key="index" :label="item.orgName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="9" :offset="1"  v-if="moreSearchItem">
            <el-form-item label="预警级别：">
              <el-select v-model="form.warnLevel" style="width:100%">
                <el-option label="全部" value=""></el-option>
                <el-option label="普通" :value="1"></el-option>
                <el-option label="严重" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="moreSearchItem" style="position:relative;">
            <el-form-item label="预警项：" props="projectCode">
              <el-cascader
                      placeholder="试试搜索：交易数据预警"
                      style="width: 100%;"
                      ref="cascaderSelectRef"
                      v-model="cascaderValue"
                      :props="props"
                      clearable
                      :options="options"
                      filterable>
                <template slot-scope="{ node, data }">
                  <span :title="data.label">{{ data.label }}</span>
                </template>
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="6"  v-if="moreSearchItem">
            <el-form-item label="预警时间：">
              <el-date-picker
                      style="width: 100%"
                      v-model="datetimerange"
                      type="datetimerange"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" >
            <el-form-item label="">
                <div >
                    <el-button plain size="small" type="primary"   @click="reflash">重置</el-button>
                    <el-button size="small" type="primary"  @click="seachBtn">搜索</el-button>
                    <el-button size="mini" type="text" v-if="!moreSearchItem" @click="moreSearchItem = true" >| 展开</el-button>
                    <el-button size="mini" type="text" v-if="moreSearchItem" @click="moreSearchItem = false" >| 收起</el-button>
                </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <space :left="-20" :right="-20" :bottom="12" />
    <el-row>
        <el-col :span="24" style="margin-bottom: 10px">
            <el-button size="small" v-if="deleteBtnShow" icon="el-icon-delete" type="primary"
                       @click="deleteSelectItem()">批量删除
            </el-button>
            <el-button size="small" v-if="deleteBtnShow" icon="el-icon-success" type="primary"
                       @click="selectAll(true)">全选
            </el-button>
            <el-button size="small" v-if="deleteBtnShow" icon="el-icon-success" type="primary"
                       @click="selectAll(false)">反选
            </el-button>
            <el-button size="small" v-if="hasBtnPermission('btn_jz_tradding_warnings_delete')" :icon="deleteBtnShow?'el-icon-close':'el-icon-delete'" type="primary"
                       @click="triggerDeleteBtn">{{deleteBtnShow?'取消':'删除数据'}}
            </el-button>
          </el-col>
    </el-row>
      <el-row :gutter="15" :style="{'min-height':tableMaxHeight}" v-loading="dataListLoading">
        <el-col :span="8" v-for="item in list" :key="item.id">
          <el-card class="projectCard">
            <div class="processStatus">
              <img :src="pendingImg" v-if="item.historyid == -1" :style="{'opacity':item.warnLevel ==1?'0.5':'1'}">
              <img :src="processedImg" v-if="item.historyid == 0">
              <img :src="ignoreImg" v-if="item.historyid == 1">
            </div>
            <div slot="header" class="clearfix">
              <span class="title" :title="item.businessName" @click="showDetail(item.id, item.businessName)">{{item.businessName}}</span>
              <p class="deleteBtn" v-if="deleteBtnShow">
                <i :style="{'color':hasSelect(item.id)?'#5cb6ff':'#c0c4cc'}"  @click="triggerSelectItem(item.id)" :class="hasSelect(item.id)?'el-icon-circle-check':'el-icon-circle-close'"></i>
              </p>
              <p><span>编号：</span><span :title="item.businessCode">{{item.businessCode}}</span></p>
            </div>
            <p class="info"><span>预警项：</span><span :title="item.itemName">{{item.itemName}}</span></p>
            <p class="info"><span style="line-height: 22px">预警级别：</span><el-tag :type="item.warnLevel ==1?'':'danger'" size="small" :hit="false" effect="plain">{{item.warnLevel ==1?"普通":"严重"}} </el-tag></p>
            <p class="info"><span>预警时间：</span><span >{{formatDate(item.warnTiime,'yyyy-MM-dd HH:mm')}}</span></p>
            <!--            <div class="tagWrapper">-->
            <!--              <el-tag :type="item.warnLevel ==1?'info':'danger'" size="small" :hit="false" effect="plain">{{item.warnLevel ==1?"普通":"严重"}} </el-tag>-->
            <!--            </div>-->
            <div class="btnWrapper" v-if="hasBtnPermission('btn_jz_tradding_warnings_show')" >
              <el-button size="small" type="text" @click="showDetail(item.id, item.businessName)">查看 >> </el-button>
            </div>
          </el-card>
        </el-col>
        <emptyInfo v-if="list.length == 0" :emptyMsg="'暂无表单数据'" ></emptyInfo>
      </el-row>

      <!-- <el-pagination
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
              :current-page="pageIndex"
              :page-sizes="[9, 18, 36, 45]"
              :page-size="pageSize"
              :total="totalCount"
              layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination> -->
      <pagination
            class="limit"
            :page-sizes="[9, 18, 36, 45]"
            :total="totalCount"
            :page.sync="pageIndex"
            :limit.sync="pageSize"
            @pagination="paginationChange">
        </pagination>
    </div>
  </div>
</template>

<script>
  import 'element-ui/lib/theme-chalk/index.css';
  import {removeTabHandle} from '@/utils/routeTab';
  import emptyInfo from '@/components/empty-info';
  import {nearSixYearsList} from '@/utils/index';
  import space from '../../common/components/space.vue';
  import Pagination from '@/components/Pagination.vue';

  export default {
    components: {
      emptyInfo,
      space,
      Pagination
    },
  data() {
    return {
      tableMaxHeight: 0,
      yearsList:[],
      dataListLoading: false,
      processedImg:require('@/assets/images/status_processed.png'),
      pendingImg:require('@/assets/images/status_pending.png'),
      ignoreImg:require('@/assets/images/status_ignore.png'),
      deleteBtnShow:false,
      selectDeleteList:[],
      form:{
        warnYear:new Date().getFullYear(),
        name:'',
        code:'',
        warnItemId:'',
        warnLevel:'',
        date:'',
        dataType: 1,
        tradeId: '', // 交易中心ID
      },
      props: {
        multiple: true,
        lazy: true,
        value:"type",
        lazyLoad:this.lazyLoad,
      },
      cascaderValue:null,
      options: [],
      datetimerange:[],
      moreSearchItem:false,
      pageIndex: 1,
      pageSize: 9,
      totalCount: 0,
      list:[],
      transactionCenterList: [],
    };
  },
  created() {
    this.yearsList = nearSixYearsList(this.form.warnYear)
    this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));
  },

  activated() {

    this.getDataContent();

  },

  mounted() {

    const that = this;
    let resizeTag = true;
    window.onresize = () => {
      if(resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();

    this.getWarnItemTreeData()

  },
  methods: {

    ifmove() {


      let hasBtnPermisson = this.hasBtnPermission("btn_jz_tradding_warnings_delete");
      let tableMaxHeight = ( document.documentElement.clientHeight - 370 +  (hasBtnPermisson ? 0 : 33) ) + 'px';
      this.pageIndex = 1
      if(document.documentElement.clientHeight >900){
        this.pageSize = 9
      }else if(document.documentElement.clientHeight < 770){
        this.pageSize = 6
      }else{
        this.pageSize = 6
      }
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight
      })
      // this.getDataContent();

    },


    triggerDeleteBtn(){
      this.deleteBtnShow = !this.deleteBtnShow;
      this.selectDeleteList = [];
    },
    hasSelect(id){
      let index = this.selectDeleteList.indexOf(id);
      return index > -1
    },
    triggerSelectItem(id){
      let index = this.selectDeleteList.indexOf(id);
      if(index > -1){
        this.selectDeleteList.splice(index,1);
      }else{
        this.selectDeleteList.push(id)
      }
    },

    selectAll(flag){
      const that = this;
      this.list.forEach(item=>{
        let index = that.selectDeleteList.indexOf(item.id)
        if(flag && index == -1){
          that.selectDeleteList.push(item.id)
        }
        if(!flag){
          that.triggerSelectItem(item.id)
        }
      })
    },

    deleteSelectItem() {
      if (this.selectDeleteList.length > 0) {

        this.$confirm(`确定要删除该数据?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          this.$http.post('/jzWarnRecords/delete',{
            idList:this.selectDeleteList
          }).then(res => {
            if (res.data.code == '1') {
              this.$message({
                type: 'success',
                message: res.data.msg
              })
              this.getDataContent();
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        })

      } else {
        this.$message({
          type: 'error',
          message: "未选择删除项。"
        })
      }
    },



    lazyLoad(node, resolve) {
      let level = node.level;
      let result;

      if(level == 2){

        this.$http({
          url: `/warnItem/listWarnItemBuType?warnType=`+node.data.type,
          method: 'get'
        }).then(({data}) => {
          if (data) {
            result = data.data;
            result.forEach((item) => {
              item.type = item.rootId;
              item.label = item.itemName;
              item.leaf = true;
            });
            resolve(result);

          } else {
            this.tableData = []
          }

        })

      }else{
        resolve(result);
      }

    },

    getWarnItemTreeData(){

      this.$http({
        url: `/warnItem/getWarnItemTree`,
        method: 'get'
      }).then(({data}) => {
        if (data) {
          var tree = data.data;
          this.options = tree[0].children;
        } else {
          this.tableData = []
        }
      })
    },

    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataContent();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataContent();
    },
    paginationChange(obj){
        this.pageIndex= obj.page||1
        this.pageSize=obj.limit||10
        this.getDataContent();
    },
    reflash() {
      this.pageIndex = 1;
      this.$refs['form'].resetFields();
      this.datetimerange=[];
      this.form = {
        warnYear:new Date().getFullYear(),
        name:'',
        code:'',
        warnItemId:'',
        warnLevel:'',
        date:'',
        dataType: 1
      };
      this.cascaderValue =null;

      this.getDataContent()
    },
    seachBtn() { //搜索按钮
      this.pageIndex = 1;
      this.getDataContent()
    },
    yearsChange(val){
      this.yearsList = nearSixYearsList(val)
      this.getDataContent()
    },
    getDataContent() {
      if(this.moreSearchItem){
        if(this.cascaderValue && this.cascaderValue.length > 0){
          var checkNode = this.$refs.cascaderSelectRef.getCheckedNodes(true);
          var warmItems = [];
          checkNode.forEach((item) => {
            if(item.value){
              warmItems.push(item.value)
            }
          });
          if(warmItems.length > 0){
            this.form.itemIdList = warmItems;
          }
        }else{
          this.form.itemIdList = [];
        }

      }

      this.form.startTime = this.datetimerange[0]?this.datetimerange[0]:"";
      this.form.endTime = this.datetimerange[1]?this.datetimerange[1]:"";
      // this.form.date = this.datetimerange[1]?this.datetimerange[1]:"";
      this.dataListLoading=true;
      this.$http({
        url: '/jzWarnRecords/list',
        method: 'post',
        data: {
          filter: this.form,
          page: this.pageIndex,
          rows: this.pageSize,
        }
      }).then(({data}) => {
        if (data) {
          this.dataListLoading=false;
          this.totalCount = data.total
          this.list = data.rows
        }
      })
    },
    showDetail(id) {
      removeTabHandle("warn_record_detail")
      this.$router.push({
        name: "warn_record_detail",
        query: {
          id:id
        },
      });
    }
  },
  filters: {
    //文字数超出时，超出部分使用...
    ellipsis(value) {
      if (!value) return ''
      if (value.length > 10) {
        return value.slice(0, 10) + '...'
      }
      return value
    }
  }
}
</script>
<style lang="less" scoped >


  .projectCard{
    /deep/ .el-card__body{
      padding: 0;
    }
    /deep/ .el-card__header{
      padding: 16px 16px 0px 16px;
      min-height: 82px;
    }
    .processStatus{
      top: 20px;
    }
  }


</style>